import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';

export function setActiongoalAction(actionGoal) {
    return { type: "GET_ACTION_GOAL", actionGoal};
}

export function getActiongoalAction(id) {
    return dispatch => {
        Common.reactLoader("show", "please wait...");
        fetch(Config.domainUrl+'action-goal/'+id, {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization':'Bearer ' +Common.getTokenData()
            }
        }).then((response) => response.json()).then((responseJson) => { 
            Common.reactLoader("hide");
            dispatch(setActiongoalAction(responseJson.data));
            
           

        }).catch(error => {
            console.error(error);
            
        });
     
    };
}


// WEBPACK FOOTER //
// ./src/actions/actiongoalAction.js